const accentGradient = {
  primary: {
    primary: 'linear-gradient(180deg, #80B344 0%, #5A8D1D 100%)',
    hover:
      'linear-gradient(0deg, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15)), linear-gradient(180deg, #80B344 0%, #5A8D1D 100%)',
    active:
      'linear-gradient(0deg, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), linear-gradient(180deg, #80B344 0%, #5A8D1D 100%)',
  },
  secondary: {
    primary: 'linear-gradient(140.14deg, #E6F3F9 0%, #E6F9F6 100%)',
    active:
      'linear-gradient(0deg, rgba(16, 60, 67, 0.1), rgba(16, 60, 67, 0.1)), linear-gradient(140.14deg, #E6F3F9 0%, #E6F9F6 100%)',
    hover:
      'linear-gradient(0deg, rgba(16, 60, 67, 0.05), rgba(16, 60, 67, 0.05)), linear-gradient(140.14deg, #E6F3F9 0%, #E6F9F6 100%)',
  },
};

const lightGradient = {
  primary:
    'linear-gradient(140.14deg, rgba(230, 243, 249, 0.4) 0%, rgba(230, 249, 246, 0.4) 100%)',
  text: 'linear-gradient(140.14deg, #E6F3F9 0%, #E6F9F6 100%), linear-gradient(0deg, rgba(16, 60, 67, 0.1), rgba(16, 60, 67, 0.1))',
};

const pageGradient = {
  primary: 'linear-gradient(180deg, #EEF3FB 0%, #E6EDF8 100%)',
};

export const gradients = {
  pageGradient,
  lightGradient,
  accentGradient,
};
